import { useController, useFormContext } from 'react-hook-form';
import { ScheduledDateTimeField } from '..';

type Props = {
  /** フィールドの非活性状態 */
  disabled?: boolean;
};

/**
 * 予約投稿の日付・時刻入力の RHF コントローラー。
 * scheduledDate / scheduledTime フィールドを内部で管理し、
 * ScheduledDateTimeField に値・ハンドラ・エラーを渡す。
 * 利用には FormProvider の配下に置くこと。
 */
export const ScheduledDateTimeFieldController: React.FC<Props> = ({ disabled }) => {
  const { control } = useFormContext();

  const {
    field: dateField,
    fieldState: { error: dateError },
  } = useController({ control, name: 'scheduledDate' });

  const {
    field: timeField,
    fieldState: { error: timeError },
  } = useController({ control, name: 'scheduledTime' });

  return (
    <ScheduledDateTimeField
      scheduledDate={dateField.value}
      scheduledTime={timeField.value}
      disabled={disabled}
      onDateChange={dateField.onChange}
      onTimeChange={timeField.onChange}
      dateError={dateError?.message}
      timeError={timeError?.message}
    />
  );
};
